import { render, staticRenderFns } from "./GenreCard.vue?vue&type=template&id=0639d571&"
import script from "./GenreCard.vue?vue&type=script&lang=js&"
export * from "./GenreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports